"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Diff = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var DrawingTool_1 = require("components/DrawingTool");
var enhanceDiff = (0, recompose_1.compose)(recompose_1.pure);
exports.Diff = enhanceDiff(function (props) {
    if (!props.beforeRevision.preview || !props.afterRevision.preview) {
        return null;
    }
    return (React.createElement("div", { className: 'image-preview dwg' },
        React.createElement("div", { className: 'viewer-task-container overlay' },
            React.createElement(DrawingTool_1.DrawingArea, { id: props.beforeRevision.uuid, image: [
                    "".concat(__APIBASEURL__, "api/files/compare/").concat(props.beforeRevision.preview.uuid, "/").concat(props.afterRevision.preview.uuid)
                ], markings: [], addMarking: function () {
                    return;
                }, onLoaded: function () {
                    return;
                } }))));
});
exports.default = exports.Diff;
